import React, { useState } from 'react';
import { useFormikContext } from 'formik';

import documentTypeService from '../../../service/newDocumentType.service';
import { DeleteDialogUI, TabsUI } from '../../Interface';
import DocumentTypeAttachmentTab from './DocumentTypeAttachmentTab';

const DocumentTypeTabs = (props) => {
  const { values, setFieldValue } = useFormikContext();
  const { user, selectedValues, setSelectedValues, disabled, setRefetchTable, languageOptions } = props;
  const [activeTab, setActiveTab] = useState(0);
  const [removeElement, setRemoveElement] = useState(null);
  const [deleteDialog, setDeletDialog] = useState(false);

  const handleDelete = (data) => {
    setRemoveElement(data.id);
    setDeletDialog(true);
  };

  const hideDeleteDialog = () => {
    setDeletDialog(false);
    setRefetchTable(true);
  };

  const handleRemoveElement = () => {
    documentTypeService.deleteFile(removeElement, user.userId).then((data) => {
      setRefetchTable(true);
      setSelectedValues((prev) => ({ ...prev, printReport: data }));
      setFieldValue(
        'printReport',
        (data ?? []).map((row) => ({
          ...row,
          langCode: row.langCode ?? row.language?.code ?? null,
          isDraft: false,
        }))
      );
      hideDeleteDialog();
    });
  };

  const tabs = [
    {
      id: 0,
      name: 'Riport mellékletek',
      content: (
        <DocumentTypeAttachmentTab
          attachmentRows={values.printReport ?? []}
          setAttachmentRows={(nextValue) => {
            const nextRows = typeof nextValue === 'function' ? nextValue(values.printReport ?? []) : nextValue;
            setFieldValue('printReport', nextRows);
          }}
          disabled={disabled}
          handleDelete={handleDelete}
          languageOptions={languageOptions}
        />
      ),
    },
  ];

  return (
    <div className="my-4 mt-6">
      <div className="px-3">
        <TabsUI activeTab={activeTab} handleTabClick={setActiveTab}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
      <DeleteDialogUI handleRemoveElement={handleRemoveElement} show={deleteDialog} onHide={hideDeleteDialog} />
    </div>
  );
};

export default DocumentTypeTabs;
